import { useSelector } from 'react-redux'
import { userSlector } from '../redux/slices/userSlice'

const useAuth = (roles: Array<number | string> = []) => {
  const user = useSelector(userSlector)

  return user?.isLoggedIn
}

export default useAuth
